import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { DownloadCountsReportResult, ReportFilter } from '../../../../models/analytics.model';
import { AnalyticsService } from '../../../../services/analytics.service';
import { NotifierService } from 'angular-notifier';
import { ConfirmationService, SelectItem, FilterService } from 'primeng/api';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import { DropdownModule } from 'primeng/dropdown';
import { Table, TableModule } from 'primeng/table';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-report-download-counts',
  templateUrl: './report-download-counts.component.html',
  styleUrls: ['./report-download-counts.component.css']
})
export class ReportDownloadCountsComponent implements OnInit,OnChanges {
//reportData:DownloadCountsReportResult[]=[];
loading: boolean;
 cols: any[];

@Input() reportFilters: ReportFilter;
@ViewChild('dt') dt:Table;
  reportData:DownloadCountsReportResult[]=[];
  reportNames: SelectItem[];
  countries: SelectItem[];
  posts: SelectItem[];
  reportNumbers: SelectItem[];
  distributionTypes: SelectItem[];
  reportTypes:SelectItem[];
  programAreas:SelectItem[];
  reportCategories:SelectItem[];
  reportYears:SelectItem[];
  downloadsCount:SelectItem[];
  dueDates:SelectItem[];
  publishDates:SelectItem[];

  constructor(private analyticsService:AnalyticsService,
  private lookupService: LookupService,private notifier:NotifierService,
  private filterService: FilterService
  ) { }

  ngOnInit() {
     // this.LoadTableFilters(this.reportData);
     this.filterService.filters['custom'] = (value, filter: any): boolean => {
      let found:number =0;
     if (filter === undefined || filter === null || filter === '') {
       return true;
     }

     if (value === undefined || value === null || !value.length) {
       return false;
     }
     filter.forEach(element => {
       if(value.indexOf(element)>-1)
          found=found+1;

     });
     if(found>0)
      return true;
     else
     return false;

   };

  }
  ngOnChanges(changes:any)
  {
    //if(!changes.firstChange)
     this.LoadReportData();

          }

  private LoadReportData()
  {
    //console.log(this.reportFilters);
    this.analyticsService.getReportDownloadsCount$(this.reportFilters)
    .pipe(finalize(() => (this.loading = false)))
    .subscribe(resp=>{
      if(resp.ok)
      this.reportData = resp.body;
      this.LoadTableFilters(this.reportData);
    },
    error=>{
      this.notifier.notify('error','Error displaying report,please contact Tech Support');
      console.error('Error getting data via subscribe() method:', error);
    },
    ()=>{
      this.makeRowsSameHeight();
    });
    this.cols = [
        { field: 'reportNumber', header: 'Report Number' },
        { field: 'reportName', header: 'Report Name' },
        { field: 'reportYear', header: 'Report Year' },
        { field: 'country', header: 'Country' },
        { field: 'post', header: 'Post' },
        { field: 'programArea', header: 'Program Area' },
        { field: 'reportCategory', header: 'Report Category' },
        { field: 'reportType', header: 'Report Type' },
        { field: 'distributionType', header: 'Distribution Type' },
        { field: 'reportDueDate', header: 'Due Date' },
        { field: 'reportPublishDate', header: 'Published Date' },
        { field: 'downloadcounts', header: 'No of Downloads' },
      ];


  }
  filter(value:any,colName:string,matchMode:any)
  {
     this.dt.filter(value,colName,matchMode);
     this.makeRowsSameHeight();

  }

  makeRowsSameHeight() {
    setTimeout(() => {
        if (document.getElementsByClassName('p-table-scrollable-wrapper').length) {
            let wrapper = document.getElementsByClassName('p-table-scrollable-wrapper');
            for (var i = 0; i < wrapper.length; i++) {
               let w = wrapper.item(i) as HTMLElement;
               let frozen_rows: any = w.querySelectorAll('.p-table-frozen-view tr');
               let unfrozen_rows: any = w.querySelectorAll('.p-table-unfrozen-view tr');
               for (let i = 0; i < frozen_rows.length; i++) {
                  if (frozen_rows[i].clientHeight > unfrozen_rows[i].clientHeight) {
                     unfrozen_rows[i].style.height = frozen_rows[i].clientHeight+"px";
                     }
                  else if (frozen_rows[i].clientHeight < unfrozen_rows[i].clientHeight)
                  {
                     frozen_rows[i].style.height = unfrozen_rows[i].clientHeight+"px";
                  }
                }
              }
            }
     },300);
       }
  LoadTableFilters(reportData: DownloadCountsReportResult[]) {
  this.reportNumbers = this.GetUniqueValues(reportData.map(r => r.reportNumber));
  this.reportNames = this.GetUniqueValues(reportData.map(r => r.reportName));
  this.countries = this.GetUniqueValues(reportData.map(r => r.country));
  this.reportYears = this.GetUniqueValues(reportData.map(r => r.reportYear));
  this.distributionTypes = this.GetUniqueValues(reportData.map(r => r.distributionType));
  this.posts = this.GetUniqueValues(reportData.map(r => r.post));
  this.reportTypes = this.GetUniqueValues(reportData.map(r => r.reportType));
  this.programAreas = this.GetUniqueValues(reportData.map(r => r.programArea));
  this.reportCategories = this.GetUniqueValuesWithComa(reportData.map(r => r.reportCategory));
  this.dueDates = this.dateSort(reportData.map(r => r.reportDueDate));
  this.publishDates = this.dateSort(reportData.map(r => r.reportPublishDate));
  this.downloadsCount = this.GetUniqueValues(reportData.map(r => r.downloadcounts));

  }
  dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

     GetUniqueValues(vals: any[]):SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
      //console.log(returnArry.length);
    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
  GetUniqueValuesWithComa(vals: any[]):SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      var splitVal=vals[cnt].split(',');
      for (let i = 0; i < splitVal.length; i++) {
        if (returnArry.filter(r => r.label == splitVal[i]).length == 0)
        returnArry.push({ label:splitVal[i], value:splitVal[i]});
      }
    }
      //console.log(returnArry.length);
    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }
 onPage(first:number,rows:number)
  {
    this.makeRowsSameHeight();
  }
}
